import appleIIe from "./images/appleIIe.jpg";
import poolrad from "./images/poolrad.jpg";
import ncsamosaic from "./images/ncsamosaic.jpg";
import cprog from "./images/cprog.png";
import college from "./images/college.jpg";
import future from "./images/future.jpg";

const content = [
  {
    id: 1,
    startYear: "1988",
    endYear: "1992",
    timelineText: "First Encounter with Computers (Elementary School)",
    content: <div>
      <h1 className="contentHeader">1988 - 1992: First Encounter with Computers</h1>
      <div style={{ textAlign: "center" }}><img src={appleIIe} style={{ maxHeight: "400px" }} alt="Apple IIe" /></div>
      <p className="modalText">Roughly 1988 marked my first real encounter with a computer, a hand-me-down Apple IIe from my mother's side of the family. Over the next six years, my understanding of computers was shaped heavily by my experiences with Apple machines at home and school.</p>
      <p className="modalText">Technically, my first programming language was Apple BASIC. I learned fundamentals like logical branching, loops, variables, and data types, though my programs were quite simple. Games like <em>Oregon Trail</em>, <em>Taipan</em>, and <em>Where in the World is Carmen Sandiego</em> captivated me, honing my knowledge of geography and history.</p>
      <p className="modalText">By middle school, I was proficient in virtually every program on a Mac. HyperCard fascinated me, and I vividly recall thinking, "Who stole this from HyperCard?" when I encountered my first hyperlink on the web.</p>
      <p>Image by All About Apple museum official web site - http://www.allaboutapple.com/, CC BY-SA 3.0, https://commons.wikimedia.org/w/index.php?curid=1049963</p>
    </div>,
  },
  {
    id: 2,
    startYear: "1992",
    endYear: "1994",
    timelineText: "Exploring PCs (Middle School)",
    content: <div>
      <h1 className="contentHeader">1992 - 1994: Exploring PCs</h1>
      <div style={{ textAlign: "center" }}><img src={poolrad} style={{ maxHeight: "400px" }} alt="Pool of Radiance" /></div>
      <p className="modalText">Around 1992, we purchased our first non-Apple PC, a Gateway 2000 with a 486 "DX2" processor running at 66 MHz. This powerhouse featured 64K of RAM and a 512 MB hard drive. It was cutting-edge at the time and became a cornerstone for both my dad and me.</p>
      <p className="modalText">While my dad used a CAD program for farm and city engineering projects, I immersed myself in games, Encarta articles, and tinkering with the hardware. My favorite game was <em>The Summoning</em>, a role-playing game with subpar graphics but addictive gameplay.</p>
      <p className="modalText">Adventure games like <em>Pool of Radiance</em> and (secretly) <em>Leisure Suit Larry</em> at my friend's house cemented my love for solving challenges through creative problem-solving.</p>
    </div>,
  },
  {
    id: 3,
    startYear: "1994",
    endYear: "1997",
    timelineText: "Discovering the Internet (Early High School)",
    content: <div>
      <h1 className="contentHeader">1994 - 1997: Discovering the Internet</h1>
      <div style={{ textAlign: "center" }}><img src={ncsamosaic} style={{ maxHeight: "400px" }} alt="NCSA Mosaic" /></div>
      <p className="modalText">By 1994, the internet arrived in our town, revolutionizing my life. With a modem connecting our PC to local servers, I explored bulletin boards (BBS), downloaded freeware games, and discovered the wonders of email and ASCII-based communication.</p>
      <p className="modalText">I also delved into Unix servers via my sister's college account, experimenting with public HTML directories, Usenet newsgroups, and Telnet. These early forays into networking opened up a world of exploration and connection.</p>
      <p className="modalText">Coincidentally, my dad met his future wife, Cindy, on Prism BBS during this period, showcasing the internet's transformative power even in its infancy.</p>
    </div>,
  },
  {
    id: 4,
    startYear: "1997",
    endYear: "1998",
    timelineText: "Diving Deeper (Late High School)",
    content: <div>
      <h1 className="contentHeader">1997 - 1998: Diving Deeper into Technology</h1>
      <div style={{ textAlign: "center" }}><img src={cprog} style={{ maxHeight: "400px" }} alt="C Programming" /></div>
      <p className="modalText">Cindy moved in with us around this time, and my passion for computers deepened. I spent countless hours gaming, exploring MUDs (multi-user dungeons), and teaching myself HTML and C programming from books.</p>
      <p className="modalText">These formative experiences laid the groundwork for my future in technology, even as I balanced them with the usual challenges of late high school.</p>
    </div>,
  },
  {
    id: 5,
    startYear: "1998",
    endYear: "2005",
    timelineText: "College and Growth as a Technologist",
    content: <div>
      <h1 className="contentHeader">1998 - 2005: College and Growth</h1>
      <div style={{ textAlign: "center" }}><img src={college} style={{ maxHeight: "400px" }} alt="College Days" /></div>
      <p className="modalText">Starting college in 1998, I bypassed the introductory programming course thanks to my prior knowledge of C. However, the journey from an amateur coder to a professional was anything but smooth.</p>
      <p className="modalText">Through determination and a hunger for knowledge, I transitioned into the professional world by 2005. While the path wasn’t always clear, the continuous drive to learn kept me moving forward, shaping the technologist I am today.</p>
    </div>,
  },
  {
    id: 6,
    startYear: "Now",
    endYear: "Future",
    timelineText: "What will you see next?",
    content: <div>
      <h1 className="contentHeader">Now - Future: What Wonders Will You See?</h1>
      <div style={{ textAlign: "center" }}><img src={future} style={{ maxHeight: "400px" }} alt="College Days" /></div>
      <p className="modalText">Now that you've seen all the changes in technology that have happened from when I was young until now, just think about what the world will be like when you are my age (45)!</p>
    </div>,
  },
];

export default content;
